/* eslint-disable import/max-dependencies */
import {
  takeEvery, select, call, put,
} from "redux-saga/effects";
import { setErrors, addNotification, type Response } from "@fas/ui-framework";
import { SAVE_LINKING_ITEM_SAGA, SAVE_LINKING_LOADING } from "../../helpers/constants";
import { getLinkingInfo } from "../../selectors/linking";
import LinkingApi from "../../services/linkingApi";
import setLoading from "../../actions/loading";
import { getHashValue } from "../../services/jusCan";
import { getLinkingSortings } from "../../selectors/accountModules";
import { schema } from "./schema";
import errorsTransform from "../../helpers/errorsTransform";
import type { SaveLinkingInfoSaga } from "../../actions/linkingList";
import type { Sorting as LinkingInfoSorting, LinkingInfo } from "../../components/LinkingInfoForm/types/LinkingInfoForm.types";

export function* makeFetch(action: SaveLinkingInfoSaga) {
  const { navigate } = action;
  const linkingInfoRaw: unknown = yield select(getLinkingInfo);
  const linkingInfo: LinkingInfo = linkingInfoRaw as LinkingInfo;
  const sortings: Array<LinkingInfoSorting> = yield select(getLinkingSortings);
  const mainSchema = schema(sortings);

  const validationResult = mainSchema.validate(linkingInfo);
  const validationErrors = errorsTransform(validationResult);

  yield put(setErrors(validationErrors));
  if (Object.keys(validationErrors).length) {
    return;
  }

  yield put(setLoading(SAVE_LINKING_LOADING, true));

  try {
    if (linkingInfo.id) {
      yield call(
        LinkingApi.updateLinkingInfo as any,
        linkingInfo.id,
        linkingInfo
      );
      yield put(addNotification({ message: "Successfully saved", severity: "success" }));
    }
    else {
      const response: {
        data: {
          data: { id: string },
        },
      } = yield call(LinkingApi.createLinkingInfo as any, linkingInfo);
      const {
        data: {
          data: { id: linkingId },
        },
      } = response;

      yield put(addNotification({ message: "Successfully created", severity: "success" }));
      navigate(`/linking/edit/${linkingId}?hashId=${getHashValue()}`);
    }
  }
  catch (error: any) {
    if (error.errorMessage && (
      error.errorMessage === "Error DB save." || error.errorMessage.endsWith("is not unique for current account.")
    )) {
      yield put(addNotification({ message: "Linking name already exists", severity: "error" }));
    }
    else {
      yield put(addNotification({ message: error.errorMessage || "Failed to save", severity: "error" }));
    }
    // eslint-disable-next-line no-console
    console.error(error);
  }
  finally {
    yield put(setLoading(SAVE_LINKING_LOADING, false));
  }
}

export default function* watch() {
  yield takeEvery(SAVE_LINKING_ITEM_SAGA, makeFetch);
}
